import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleMaps } from '/app/node_modules/@nuxt/scripts/dist/runtime/registry/google-maps.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleMaps = useScriptGoogleMaps({})
    return { provide: { $scripts: { googleMaps } } }
  }
})